import { userChangePasswordSuccess, userChangePasswordError, resetChangePasswordState } from "./reducer";
import { changePasswordApi } from "services/authServcies";


export const userChangePassword =
  (user: any, history: any) => async (dispatch: any) => {

    try {
      const response = await changePasswordApi({
        old_password: user.old_password,
        new_password: user.new_password,
      });

      if (response.success) {
        dispatch(
          userChangePasswordSuccess(response.message||"Password updated successfully")
        );

      }
    } catch (forgetError) {
      dispatch(userChangePasswordError(forgetError));
    }
  };
